export default __webpack_public_path__ + "static/media/Datorsal3.08a7f7fd.jpeg";